export default "__VITE_ASSET__BrmgscO$__"